import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {ManufacturerSearchModel} from "../manufacturer-search.model";
import {ManufacturerSearchPageComponent} from "../manufacturer-search-page/manufacturer-search-page.component";
import {ManufacturerEditPageComponent} from "../manufacturer-edit-page/manufacturer-edit-page.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-manufacturer-single-select-edit-contorl",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(ManufacturerSingleSelectEditControlComponent),
        provideSearchModel(ManufacturerSearchModel)
    ]

})
export class ManufacturerSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<ManufacturerSearchModel> {
    constructor(model: ManufacturerSearchModel, injector: Injector) {
        super(model, injector, "manufacturerId", "name");
        this.extendedSearchComponent = ManufacturerSearchPageComponent;
        this.extendedEditComponent = ManufacturerEditPageComponent;
    }
}
